// removed by extract-text-webpack-plugin
module.exports = {"submitBtn":"_1N7oFS90iHCS9mouj2Ga1R_0","wrapper":"_2fG4PN1G58DrYaUNFizdnD_0","part":"_1owmpTH54uY88hyMC6tAjR_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a89f2ac","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserInfo/Avatar.vue
// module id = UMlE
// module chunks = 1